import styled from "styled-components";

export const LineBox = styled.hr`
    margin: 0;
    background-color: ${props => props.theme.border.mainColor};
    width: 100%;
`
